<template>
  <div>
    <meu-menu> </meu-menu>
    <b-container class="adjustment-margin container-margin-top">
      <b-row>
        <candidato-login
          v-if="this.token == null || this.token.length == 0"
        ></candidato-login>

        <!-- //? Verificação do email -->
        <div
          class="component-display"
          v-if="
            this.user.id !== null &&
            this.user.id > 0 &&
            this.token !== null &&
            this.token.length > 0 &&
            this.showEmailAtivar == true
          "
        >
          <b-row
            v-if="!dismissCountDown"            
            class="d-flex align-items-center flex-column"
          >
            <b-form-group
              id="input-1"
              label="E-mail:"
              label-for="input-1"
              description="Um e-mail de validação será enviado para esse endereço."
            >
              <b-form-input
                class="input-c-display"
                id="input-1"
                v-model="user.email"
                type="email"
                placeholder="Enter email"
                :state="
                  this.user.token_google != null
                    ? null
                    : user.email
                    ? true
                    : false
                "
                :disabled="this.user.token_google != null"
                required
              ></b-form-input>
            </b-form-group>
            <div>
              <b-button @click="doAtivarEmail"  type="submit" class="mr-2" variant="primary">
                Enviar
              </b-button>
              <b-button  @click="showEmailAtivar=false"                              
                class="ml-2"
                variant="danger"
              >
                Voltar
              </b-button>
            </div>
          </b-row>

          
        </div>

        <b-col
          v-if="
            this.user.id !== null &&
            this.user.id > 0 &&
            this.token !== null &&
            this.token.length > 0 &&
            this.showEmailAtivar == false
          "
        >
          <b-row class="adjustment-margin container-margin-top">
            <b-col class="btn-wrapper">
              <router-link :to="{ name: 'vagas_encaminhadas' }" class="m-1">
                <b-button variant="light deep-orange" class="d-btn-w">
                  Minhas Vagas
                </b-button>
              </router-link>

              <router-link :to="{ name: 'curriculo_troca_senha' }" class="m-1">
                <b-button variant="primary" class="d-btn-w">
                  Alterar Senha
                </b-button>
              </router-link>

              <router-link :to="{ name: 'curriculo' }" class="m-1">
                <b-button variant="light deep-purple" class="d-btn-w">
                  Editar Currículo
                </b-button>
              </router-link>
            </b-col>
          </b-row>

          <b-row class="mt-2 d-flex justify-content-center" v-if="this.user.token_email==null|| this.user.token_email != 'done'">
            
          </b-row>

          <b-row class="mt-2 d-flex justify-content-center">
            <b-col md="4" sm="12" lg="4" class="mb-5">
              <div class="card-cv text-center" style="min-height: 364px">
                <div class="bg-profile">
                  <b-avatar
                    variant="light"
                    :src="user.foto.nome"
                    style="width: 120px; height: 120px"
                  ></b-avatar>
                </div>
                <div class="align-middle mt-3">
                  <h3>
                    <b>{{ user.nome }}</b>
                  </h3>
                  <p>
                    {{ user.genero.nome }} <br />
                    {{ user.data_nascimento }}
                  </p>
                  <hr />
                  <p>
                    {{ user.cpf }} <br />
                    {{ (user.email || "") | truncate(35) }}
                  </p>
                </div>
              </div>
            </b-col>
            <b-col md="4" sm="12" lg="4">
              <div
                class="card-cv indigo text-center text-white"
                style="min-height: 364px"
              >
                <div class="align-middle mt-3">
                  <h3>
                    <b>Endereço</b>
                  </h3>                  
                  <p>
                    UF: {{ user.estado_id.nome }} <br />
                    Cidade: {{ user.cidade_id.nome }} <br />                    
                  </p>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Menu from "../shared/Menu";
import Curriculo_Login from "./Curriculo_Login";
import { userService } from "../../services";
export default {
  data() {
    return {
      validarEmail: false,
      showEmailAtivar: false,
      dismissSecs: 15,
      dismissCountDown: 0,
    };
  },
  components: {
    "meu-menu": Menu,
    "candidato-login": Curriculo_Login,
  },
  computed: {
    user: function () {
      return this.$store.getters.getUser;
    },
    token: function () {
      return this.$store.getters.getToken;
    },
  },
  created() {
    if (this.$route.query.api_key && !this.$store.getters.getApiKey) {
      this.$store.dispatch("definirApiKey", this.$route.query.api_key);
    }

    this.validarEmail = this.user.emailValidado == null;
  },
  methods: {
    irVagas() {
      this.$router.push({
        name: "vagas_encaminhadas",
      });
    },
    editarCurriculo() {
      this.$router.push({
        name: "curriculo",
      });
    },
    onSubmit(e) {
      e.preventDefault();

      this.dismissCountDown = this.dismissSecs;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;

      if (this.dismissCountDown == 0) {        
        this.showEmailAtivar = false;
      }
    },
    doAtivarEmail(){
      let self = this;
      let loader = this.$loading.show();
      
      
      userService
        .ativarEmail()
        .then(function (obj) {
          if (obj.status === 200) {
            self.$swal({
              icon: "info",
              position: "top",
              title: "Ativação do email",
              text: "Foi encaminhado para o seu email umlink de confirmação.",
              footer:
                "verifique na sua caixa de entrada, caso não encontre, de uma olhadinha na caixa de SPAM!!!",
            });
          } else {
            self.$swal({
              icon: "error",
              position: "top",
              title: "Oops...",
              text: "Não foi possivel encaminhar email!",
              footer:
                "Os dados fornecidos não permitem encaminhar um email para confirmação, por favor entre em contato",
            });
          }
          loader.hide();
          self.showEmailAtivar = false;
        }); 
        
    }
  },
};
</script>

<style scoped>
.card-profile {
  text-align: center;
  padding: 30px;
  background: #fff;
  border-radius: 10px;
  text-decoration: none;
}

.card-alterar-senha {
  text-align: center;
  padding: 30px;
  background: #066cb3;
  border-radius: 10px;
  text-decoration: none;
  color: #fff;
}

.card-editar {
  text-align: center;
  padding: 30px;
  background: #06b362;
  border-radius: 10px;
  text-decoration: none;
  color: #fff;
}

.card-vagas {
  text-align: center;
  padding: 30px;
  background: #914f97;
  border-radius: 10px;
  text-decoration: none;
  color: #fff;
}

a:hover {
  text-decoration: none;
}

.alert-info {
  color: #ffffff;
  background-color: #d94452;
  border-color: #d94452;
  border-bottom: 5px solid #eb5463;
}

.deep-orange {
  background: #ff5722 !important;
  color: #fff !important;
}

.deep-purple {
  background: #5e35b1;
  color: #fff !important;
}

.indigo {
  background: #3949ab;
}

.btn-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

@media (max-width: 430px) {
  .btn-wrapper {
    flex-direction: column;
    align-items: stretch;
  }

  .d-btn-w {
    width: 100%;
  }
}

.component-display {
  height: 45vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.input-c-display {
  width: 64ch;
}

@media (max-width: 430px) {
  .input-c-display {
    width: 95vw;
    margin: 0 auto;
  }
}
</style>
